/* global axios */

import ApiClient from '../ApiClient';

class RetinoAPI extends ApiClient {
  constructor(id) {
    super('integrations/retino', { accountScoped: true });
    this.id = id;
  }

  getStates() {
    return axios.get(`${this.url}/${this.id}/states`);
  }

  searchTickets({ search, page = 1 }) {
    return axios.get(`${this.url}/${this.id}/tickets`, {
      params: {
        search,
        page,
      },
    });
  }
}

export default RetinoAPI;
